import { render, staticRenderFns } from "./contract-item-automation-modal.component.vue?vue&type=template&id=37bc61e2&scoped=true&"
import script from "./contract-item-automation-modal.component.vue?vue&type=script&lang=ts&"
export * from "./contract-item-automation-modal.component.vue?vue&type=script&lang=ts&"
import style0 from "./contract-item-automation-modal.component.vue?vue&type=style&index=0&id=37bc61e2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bc61e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VForm,VProgressCircular,VRow,VTextField})
